import { render, staticRenderFns } from "./artists.vue?vue&type=template&id=3f279438&scoped=true"
import script from "./artists.vue?vue&type=script&setup=true&lang=js"
export * from "./artists.vue?vue&type=script&setup=true&lang=js"
import style0 from "./artists.vue?vue&type=style&index=0&id=3f279438&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f279438",
  null
  
)

export default component.exports